import React, { useEffect, useRef, useState } from 'react'
import { DataTable, DataTableExpandedRows, DataTableRowEventParams } from 'primereact/datatable'
import { AutoComplete } from 'primereact/autocomplete'
import { MultiSelect } from 'primereact/multiselect'
import { Dropdown } from 'primereact/dropdown'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { FilterMatchMode } from 'primereact/api'
import { locale } from 'primereact/api'
import { InputText } from 'primereact/inputtext'
import { OverlayPanel } from 'primereact/overlaypanel'
import { Checkbox, CheckboxChangeParams } from 'primereact/checkbox'
import { classNames } from 'primereact/utils'
import { useLocation } from 'react-router-dom'
import i18n from 'i18next'
import Helmet from 'react-helmet'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

// local imports
import './Tracing.scss'
import loaderLogo from 'assets/icons/loading-statistics.png'
import locationImg from '../assets/icons/location.svg'
import noRecordImg from 'assets/icons/no-content.png'
import { ISecResAccordion, ISecurityLocations, ISecurityReservations } from 'types/TrackingType'
import AuthUtil from 'utils/AuthUtil'
import DateUtil from 'utils/DateUtil'
import useDidMountEffect from 'utils/useDidMountEffect'
import NotificationService from 'service/NotificationService'
import TracingService from 'service/TracingService'
import Loader from 'components/ui/Loader'
import DatePickerIcon from 'components/ui/DatePickerIcon'
import Private from './Private'
import { Line } from 'components/campus-service-tracing/styled'

export default function Tracing() {
  const { t } = useTranslation()
  const dt = useRef<any>(null)
  const opProperties = useRef<OverlayPanel>(null)
  const addToExcel = useRef<OverlayPanel>(null)
  const [reservations, setReservations] = useState<any[] | undefined>([])
  const [selectedLocation, setSelectedLocation] = useState<ISecurityLocations | null>(null)
  const [filteredLocation, setFilteredLocation] = useState<any>(null)
  const [countries, setCountries] = useState<any>([])
  const [filters, setFilters] = useState<any>(null)
  const [startDate, setStartDate] = useState<Date | any | undefined>(new Date())
  const [endDate, setEndDate] = useState<Date | any | undefined>(new Date())
  const [blockList, setBlockList] = useState<any>()
  const [floorList, setFloorList] = useState<any>()
  const [globalFilterValue, setGlobalFilterValue] = useState('')
  const [minDate, setMinDate] = useState<Date | undefined>()
  const [maxDate, setMaxDate] = useState<Date | undefined>()
  const [loading, setLoading] = useState<boolean>(false)
  let employee = AuthUtil.getEmployeeSummary()

  const { state } = useLocation<{ type: 'shared' | 'firm' } | undefined>()
  const isShared = !!state && state?.type === 'firm' ? false : true
  const statuses = [t('dashboard.active'), t('visitor.canceled')]
  const visit = [t('visitor.came'), t('visitor.not-come')]

  /* Get Locations for filter input */
  const getSecurityLocations = () => {
    TracingService.getGrantedSecurityLocations(isShared).then((response) => {
      let res = response.data
      res.map(
        (location) =>
          (location._fullLocationName =
            location.locationName +
            ' (' +
            location.firmName +
            ') • ' +
            location.districtName +
            '/' +
            location.cityName +
            '/' +
            location.countryName)
      )
      setCountries(res)
    })
  }

  const securityReservations = () => {
    setLoading(true)
    let securityReservationsRequest = {
      locationId: selectedLocation?.locationId!,
      startDate: startDate,
      endDate: endDate,
      isShared,
    }
    TracingService.getSecurityReservations(securityReservationsRequest).then((response) => {
      const respData = response.data.map((location) => {
        location.blockName = location.blockName.toUpperCase()
        location.floorName = location.floorName.toUpperCase()
        return location
      })

      setReservations(respData)
      let blockList = response.data
        .map((elem) => ({ name: elem.blockName.toUpperCase(), value: elem.blockId }))
        .filter((obj, pos, arr) => {
          return arr.map((mapObj) => mapObj.name).indexOf(obj.name) === pos
        })

      let floorList = response.data
        .map((elem) => ({ name: elem.floorName.toUpperCase(), value: elem.floorId }))
        .filter((obj, pos, arr) => {
          return arr.map((mapObj) => mapObj.name).indexOf(obj.name) === pos
        })
      setBlockList(blockList)
      setFloorList(floorList)
      setLoading(false)
    })
  }

  useEffect(() => {
    authorizationCheck()
    initFilters()
    initSearchButtonDisable()
    initSetDate()
    getSecurityLocations()
    securityReservations()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const initSearchButtonDisable = () => {
    var dropdownButton = document.getElementsByClassName(
      'p-button p-component p-autocomplete-dropdown p-button-icon-only'
    )
    if (dropdownButton !== undefined && dropdownButton.length > 0) {
      dropdownButton[0].classList.add('d-none')
    }
  }
  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      blockName: { value: null, matchMode: FilterMatchMode.IN },
      floorName: { value: null, matchMode: FilterMatchMode.IN },
      status: { value: null, matchMode: FilterMatchMode.EQUALS },
      visited: { value: null, matchMode: FilterMatchMode.EQUALS },
    })
  }

  const authorizationCheck = () => {
    if (!AuthUtil.isSecurity(employee?.authList)) {
      NotificationService.showUnauthorizedRedirectionPopup(
        10000,
        'Yetkisiz Kullanıcı!',
        'Burayı görüntüleme yetkiniz yok!'
      ).then(() => {
        window.location.href = '/home'
      })
    }
  }
  const initSetDate = () => {
    let nowMin = new Date('2022-01-01')
    let nowMax = new Date()
    //nowMin.setMonth(nowMin.getMonth() - 6)
    nowMax.setMonth(nowMax.getMonth() + 6)
    setMinDate(nowMin)
    setMaxDate(nowMax)
  }

  const searchLocation = (event: { query: string }) => {
    setTimeout(() => {
      let _filteredLocation
      if (!event.query.trim().length) {
        _filteredLocation = [...countries]
      } else {
        _filteredLocation = countries.filter((country: { firmName: string }) => {
          return country.firmName.toLowerCase().startsWith(event.query.toLowerCase())
        })
      }
      setFilteredLocation(_filteredLocation)
    }, 250)
  }
  const itemTemplate = (item: any) => {
    return (
      <div className="d-flex align-items-center">
        <img src={locationImg} className="ms-2 me-3 of-location-img" alt="location-marker" />
        <div className="firm-info py-2">
          <div className={'firm-name'}>{item.firmName}</div>
          <div className={'firm-district-name'}>{`${item.districtName} | ${item.cityName} | ${item.countryName}`}</div>
          <div className={'firm-location-name'}>{item.locationName}</div>
        </div>
      </div>
    )
  }

  const exportExcel = () => {
    import('xlsx').then((xlsx) => {
      var Heading = [
        [
          t('visitor.name'),
          t('visitor.surname'),
          t('visitor.email'),
          t('visitor.employee-firm'),
          t('visitor.shared-location'),
          t('most-used-words.block'),
          t('most-used-words.floor'),
          t('input-texts.date'),
          t('visitor.reservation-status'),
          t('visitor.came-office'),
        ],
      ]
      let arr: any[] = []
      reservations?.map((res) => {
        let temp: {
          Visited: any
          Status: any
          ReservationDate: any
          FloorName: any
          BlockName: any
          LocationName: any
          FirmName: any
          EMail: any
          EmployeeSurname: any
          EmployeeName: any
        } = {
          EmployeeName: res.employeeName,
          EmployeeSurname: res.employeeSurname,
          EMail: res.eMail,
          FirmName: res.firmName,
          LocationName: res.locationName,
          BlockName: res.blockName,
          FloorName: res.floorName,
          ReservationDate: moment(res.reservationDate).format('DD/MM/YYYY'),
          Status: res.status ? t('dashboard.active') : t('dashboard.passive'),
          Visited: res.visited ? t('visitor.came') : t('visitor.not-come'),
        }
        arr.push(temp)
      })

      const ws = xlsx.utils.book_new()
      xlsx.utils.sheet_add_aoa(ws, Heading)
      const worksheet = xlsx.utils.sheet_add_json(ws, arr!, { origin: 'A2', skipHeader: true })
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
      saveAsExcelFile(excelBuffer, t('visitor.reservation-tracking'))
    })
  }

  const saveAsExcelFile = (buffer: BlobPart, fileName: string) => {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      let EXCEL_EXTENSION = '.xlsx'
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      })
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION)
    })
  }
  const onClickLocation = () => {
    var button = document.getElementsByClassName('p-button p-component p-autocomplete-dropdown p-button-icon-only')
    if (button !== undefined && button.length > 0) {
      // @ts-ignore
      button[0].click()
    }
  }
  const onGlobalFilterChange = (input: any) => {
    const value = input
    let _filters = { ...filters }
    _filters['global'].value = value
    setFilters(_filters)
    setGlobalFilterValue(value)
  }

  useDidMountEffect(() => {
    if (startDate > endDate) {
      setEndDate(startDate)
    }
  }, [startDate])

  useDidMountEffect(() => {
    if (endDate < startDate) {
      setStartDate(endDate)
    }
  }, [endDate])

  //Ziyaretçi yönelgesi
  const showProperties = (e: React.MouseEvent<HTMLDivElement>) => {
    opProperties.current?.show(e, e.target)
  }
  const showExcel = (e: React.MouseEvent<HTMLDivElement>) => {
    addToExcel.current?.show(e, e.target)
  }

  //Reservation Visited Checkbox
  const onVisitedChange = (e: CheckboxChangeParams, rowData: ISecurityReservations) => {
    let visitedStatusRequest = {
      planId: rowData.planId,
      planType: rowData.planType,
      visited: e.checked,
    }
    TracingService.updateVisitedStatus(visitedStatusRequest).then((response) => {
      securityReservations()
    })
  }

  //Table Templates
  const tableHeaderTemplate = () => {
    return (
      <div className="table-header">
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row">
            <div className="me-3">
              <span className={classNames('p-input-icon-left', globalFilterValue ? 'p-input-icon-right' : '')}>
                <i className="pi pi-user" />
                <InputText
                  className="of-name-search"
                  style={{ width: '310px' }}
                  value={globalFilterValue}
                  onChange={(e) => onGlobalFilterChange(e.target.value)}
                  placeholder={t('input-texts.search-someone')}
                />
                {globalFilterValue !== '' && (
                  <i className="pi pi-times" style={{ cursor: 'pointer' }} onClick={() => onGlobalFilterChange('')} />
                )}
              </span>
            </div>
            <div
              className={'align-self-center d-flex flex-row'}
              onMouseOver={(e) => showProperties(e)}
              onMouseLeave={() => opProperties?.current?.hide()}>
              <i className="pi pi-info-circle" style={{ fontSize: '1.5rem', marginRight: '0.5rem' }}></i>
              <div className="me-3">{t('tooltip.visitor-direct')}</div>
            </div>
            <OverlayPanel ref={opProperties} id="overlay_panel" className="info-overlay-panel">
              <div className="p-3">
                <div className="fw-bold">{t('overlaypanel-texts.visitor-header')}</div>
                <div>1- {t('overlaypanel-texts.visitor-text1')}</div>
                <div>2- {t('overlaypanel-texts.visitor-text2')}</div>
                <div>3- {t('overlaypanel-texts.visitor-text3')}</div>
              </div>
            </OverlayPanel>
          </div>
          <div className="d-flex flex-row">
            <div
              className="align-self-center d-flex flex-row"
              style={{ cursor: 'pointer' }}
              onMouseOver={(e) => showExcel(e)}
              onMouseLeave={() => addToExcel.current?.hide()}
              onClick={exportExcel}>
              <i className="pi pi-file-excel excelIcon" style={{ fontSize: '25px' }}></i>
            </div>
            <OverlayPanel ref={addToExcel} className="add-excel-panel">
              <div className="add-excel-text">
                <p>{t('overlaypanel-texts.export-excel')}</p>
              </div>
            </OverlayPanel>
          </div>
        </div>
      </div>
    )
  }
  const statusBodyTemplate = (rowData: ISecurityReservations) => {
    return (
      <span className={`product-badge status-${rowData.status ? 'active' : 'passive'}`}>
        {rowData.status ? t('dashboard.active') : t('visitor.canceled')}
      </span>
    )
  }
  const checkboxBodyTemplate = (rowData: ISecurityReservations) => {
    return (
      <Checkbox
        disabled={!rowData.status}
        onChange={(e: CheckboxChangeParams) => onVisitedChange(e, rowData)}
        checked={rowData.visited}
        style={{ cursor: !rowData.status ? 'not-allowed' : '' }}></Checkbox>
    )
  }
  const dateBodyTemplate = (rowData: ISecurityReservations) => {
    let formatDate = moment(rowData.reservationDate).format('DD/MM/YYYY')
    return <span>{formatDate}</span>
  }
  const plateBodyTemplate = (rowData: ISecurityReservations) => {
    return <span>{rowData.plate || '---'}</span>
  }
  const panelHeaderTemplate = (options: any) => {
    if (options) {
      return (
        <div className="d-flex p-multiselect-header">
          <span>
            {options.checkboxElement} <label>{t('buttons.choose-all')}</label>
          </span>

          <div>{options.closeElement}</div>
        </div>
      )
    }
  }

  const blockFilterTemplate = (options: { value: any[] | undefined; filterCallback: (arg0: any) => void }) => {
    return (
      <MultiSelect
        value={options.value}
        options={blockList}
        optionLabel="name"
        panelHeaderTemplate={panelHeaderTemplate}
        optionValue="name"
        onChange={(e) => {
          options.filterCallback(e.value)
        }}
        placeholder={t('most-used-words.block')}
        className="p-column-filter filter-multiselect"
      />
    )
  }
  const floorFilterTemplate = (options: { value: any[] | undefined; filterCallback: (arg0: any) => void }) => {
    return (
      <MultiSelect
        value={options.value}
        options={floorList}
        optionLabel="name"
        optionValue="name"
        panelHeaderTemplate={panelHeaderTemplate}
        onChange={(e) => {
          options.filterCallback(e.value)
        }}
        placeholder={t('most-used-words.floor')}
        className="p-column-filter filter-multiselect"
      />
    )
  }
  const statusFilterTemplate = (options: { value: any; filterCallback: (arg0: boolean) => void }) => {
    return (
      <Dropdown
        value={options.value == null ? null : options.value ? t('dashboard.active') : t('visitor.canceled')}
        options={statuses}
        onChange={(e) => {
          options.filterCallback(e.value === t('dashboard.active'))
        }}
        placeholder={t('visitor.status')}
        className="p-column-filter filter-multiselect"
      />
    )
  }
  const visitedFilterTemplate = (options: { checked: any; value: any; filterCallback: (arg0: any) => void }) => {
    return (
      <Dropdown
        value={options.value == null ? null : options.value ? t('visitor.came') : t('visitor.not-come')}
        options={visit}
        onChange={(e) => {
          options.filterCallback(e.value === t('visitor.came'))
        }}
        placeholder={t('visitor.situation')}
        className="p-column-filter filter-multiselect"
      />
    )
  }

  const footerLeftTemplate = () => {
    return (
      <div>
        <span>{t('visitor.between')} </span>
        <span className="font-bold">"{moment(startDate).format('DD/MM/YYYY')}"</span>
        <span> - </span>
        <span className="font-bold"> "{moment(endDate).format('DD/MM/YYYY')}" </span>
        <span> {t('visitor.in-range')}</span>
        <span className="font-bold"> {reservations?.length} </span>
        {t('visitor.record')} {t('visitor.record-listed')}
      </div>
    )
  }

  const emptyMessageTemplate = () => {
    return (
      <div className="p-3 d-flex gap-2 flex-column justify-content-center align-items-center">
        <img src={noRecordImg} width={150} height={150} alt="no-record-found" />
        <span style={{ fontSize: '1.2rem', fontWeight: 700, color: '#363636' }}>{t('visitor.no-record-found')}</span>
      </div>
    )
  }

  locale(i18n.language)

  /* ################### Expanded Rows - On Campus Reservations ################### */
  type ExpandedData = {
    planId: number
    data: ISecResAccordion[]
  }
  type TableData = {
    id: string
    type: string
    resType: string
    description: string
    reservationDate: string
  }

  /* States */
  const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | undefined | any[]>(undefined)
  const [expandLoading, setExpandLoading] = useState<boolean>(false)
  const [expandedData, setExpandedData] = useState<ExpandedData[] | []>([])

  const onRowExpand = (event: DataTableRowEventParams) => {
    const { data } = event

    const params = {
      employeeId: data.employeeId,
      locationId: data.locationId,
      startDate: DateUtil.getStartOfDay(data.reservationDate).toISOString(),
      endDate: DateUtil.getEndOfDay(data.reservationDate).toISOString(),
    }

    setExpandLoading(true)
    TracingService.getSecurityResAccordion(params)
      .then((res) => setExpandedData((prev) => [...prev, { planId: data.planId, data: res.data }]))
      .catch((err) => console.log(err))
      .finally(() => setExpandLoading(false))
  }

  /* Expanded Row Template - Campus Table  */
  const rowExpansionTemplate = (data: ISecurityReservations) => {
    const selectedRowData = expandedData.find((ed) => ed.planId === data.planId)
    const rowHasExpanded = selectedRowData?.planId === data.planId

    if (!rowHasExpanded && expandLoading) return <Loader src={loaderLogo} />
    if (!selectedRowData?.data?.length)
      return <div className="font-bold text-center">{t('most-used-words.not-found')}</div>

    let tableData: TableData[] | any[] = []
    const {
      coiffeurReservation,
      doctorReservation,
      gymSaloonReservation,
      gymGroupLessonReservation,
      gymTrainerReservation,
      lactationReservation,
      parkAreaReservation,
    } = selectedRowData?.data[0]

    // check if reservation type is exists
    const hasDoctorRes = !!doctorReservation?.length
    const hasCoiffeurRes = !!coiffeurReservation?.length
    const hasGymSalonRes = !!gymSaloonReservation?.length
    const hasGymGroupRes = !!gymGroupLessonReservation?.length
    const hasGymTrainerRes = !!gymTrainerReservation?.length
    const hasLactationRes = !!lactationReservation?.length
    const hasParkAreaRes = !!parkAreaReservation?.length

    if (hasDoctorRes) {
      const doc: TableData[] = doctorReservation.map((dr) => ({
        id: `${dr.planType}_${dr.id}`,
        type: 'doctor',
        resType: '-',
        description: '-',
        reservationDate: `${dr.reservationStartHourStr} - ${dr.reservationEndHourStr}`,
      }))
      tableData.push(...doc)
    }
    if (hasCoiffeurRes) {
      const coiffeur: TableData[] = coiffeurReservation.map((cr) => ({
        id: `${cr.planType}_${cr.id}`,
        type: 'coiffeur',
        resType: '-',
        description: '-',
        reservationDate: `${cr.reservationStartHourStr} - ${cr.reservationEndHourStr}`,
      }))
      tableData.push(...coiffeur)
    }
    if (hasGymSalonRes) {
      const gymSalon: TableData[] = gymSaloonReservation.map((gymS) => ({
        id: `${gymS.planType}_${gymS.id}`,
        type: 'gym',
        resType: t('gym-res-modal.personal-res'),
        description: '-',
        reservationDate: `${gymS.reservationStartHourStr} - ${gymS.reservationEndHourStr}`,
      }))
      tableData.push(...gymSalon)
    }
    if (hasGymGroupRes) {
      const gymGroup: TableData[] = gymGroupLessonReservation.map((gymGrp) => ({
        id: `${gymGrp.planType}_${gymGrp.id}`,
        type: 'gym',
        resType: t('input-texts.gym-group-lesson'),
        description: '-',
        reservationDate: `${gymGrp.reservationStartHourStr} - ${gymGrp.reservationEndHourStr}`,
      }))
      tableData.push(...gymGroup)
    }
    if (hasGymTrainerRes) {
      const gymTrainer: TableData[] = gymTrainerReservation.map((gymTrn) => ({
        id: `${gymTrn.planType}_${gymTrn.id}`,
        type: 'gym',
        resType: t('input-texts.gym-trainer'),
        description: '-',
        reservationDate: `${gymTrn.reservationStartHourStr} - ${gymTrn.reservationEndHourStr}`,
      }))
      tableData.push(...gymTrainer)
    }
    if (hasLactationRes) {
      const lactation: TableData[] = lactationReservation.map((lac) => ({
        id: `${lac.planType}_${lac.id}`,
        type: 'lactation',
        resType: '-',
        description: '-',
        reservationDate: `${lac.reservationStartHourStr} - ${lac.reservationEndHourStr}`,
      }))
      tableData.push(...lactation)
    }
    if (hasParkAreaRes) {
      const parkArea: TableData[] = parkAreaReservation.map((park) => ({
        id: `${park.planType}_${park.id}`,
        type: 'park-area',
        resType: park.parkAreaName,
        description: park.plate,
        reservationDate: `${park.reservationStartHourStr} - ${park.reservationEndHourStr}`,
      }))
      tableData.push(...parkArea)
    }
    const theadData = ['type', 'resType', 'description', 'reservationDate']

    return (
      <div className="accordion-table">
        <table>
          <thead>
            <tr>
              <th>{t('visitor.campus-type')}</th>
              <th>{t('visitor.res-type')}</th>
              <th>{t('visitor.res-description')}</th>
              <th>{t('visitor.res-time')}</th>
            </tr>
          </thead>

          <tbody>
            {tableData.map((row) => (
              <tr key={row.id}>
                {theadData.map((key, index) => {
                  return <td key={`${row.id}_td_${index}`}>{key === 'type' ? t(`visitor.${row[key]}`) : row[key]}</td>
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <Private>
      <Helmet>
        <title>Koç Office Free - {t('nav-menu-items.visitor-tracking')} </title>
        <meta
          name="description"
          content="Office Free ile ister şirketinden, ister Koç Topluluğu ortak ofislerinden çalışma planı gerçekleştirebilir, istersen de uzaktan çalışma bildirimi yapabilirsin."
        />
      </Helmet>
      <div className="container">
        {/* Header */}
        {!!state && (
          <div style={{ color: '#363636', fontWeight: 700, fontSize: '18px', padding: '1rem 0 0' }}>
            {state?.type === 'shared'
              ? t('nav-menu-items.visitor-common-office')
              : t('nav-menu-items.visitor-firm-office')}
          </div>
        )}

        <div className="tracing-search">
          <div className="d-flex gap-2 align-items-center justify-content-between w-100">
            <div
              className={
                typeof selectedLocation === 'object' && selectedLocation !== null
                  ? 'location-autocomplete chips col-5'
                  : 'location-autocomplete col-5'
              }
              style={{ position: 'relative' }}>
              <span className="p-input-icon-left w-100">
                <i className="pi pi-map-marker" style={{ zIndex: 3 }} />
                <AutoComplete
                  value={selectedLocation}
                  field="_fullLocationName"
                  onClick={
                    typeof selectedLocation !== 'object' || selectedLocation === null
                      ? () => onClickLocation()
                      : () => {}
                  }
                  suggestions={filteredLocation}
                  className={
                    typeof selectedLocation === 'object' && selectedLocation !== null ? 'location-input w-100' : 'w-100'
                  }
                  dropdown
                  completeMethod={searchLocation}
                  forceSelection
                  itemTemplate={itemTemplate}
                  readOnly={typeof selectedLocation === 'object' && selectedLocation !== null}
                  onChange={(e) => setSelectedLocation(e.value)}
                  placeholder={t('input-texts.location-choice')}
                />
                {typeof selectedLocation === 'object' && selectedLocation !== null && (
                  <Button
                    icon="pi pi-times"
                    className="p-button-rounded p-button-text p-button-plain"
                    style={{ position: 'absolute', right: '4px', top: '6px' }}
                    onClick={() => setSelectedLocation(null)}
                  />
                )}
              </span>
            </div>

            <Line className="pi pi-ellipsis-h" />

            <div className={'col-2 datepicker'}>
              <DatePickerIcon
                showOtherMonths
                selectOtherMonths
                disabledDays={[]}
                idName={'tracing-start-date'}
                defaultDate={startDate}
                minDate={minDate}
                maxDate={maxDate}
                onSelectedDateChange={(e) => setStartDate(e.value)}
                label={t('input-texts.first-date-of-plan')}
              />
            </div>
            <div className={'col-2 datepicker'}>
              <DatePickerIcon
                showOtherMonths
                selectOtherMonths
                disabledDays={[]}
                idName={'tracing-end-date'}
                defaultDate={endDate}
                minDate={minDate}
                maxDate={maxDate}
                onSelectedDateChange={(e) => setEndDate(e.value)}
                label={t('input-texts.last-date-of-plan')}
              />
            </div>

            <Button
              style={{ width: '220px' }}
              className="search-button"
              label={t('buttons.update-list')}
              onClick={() => securityReservations()}
            />
          </div>
        </div>
        {/* Datatable */}
        <div className="mb-4">
          <div className="tracing-table">
            <div className="card p-3">
              {tableHeaderTemplate()}

              <DataTable
                expandedRows={expandedRows}
                rowExpansionTemplate={rowExpansionTemplate}
                onRowExpand={onRowExpand}
                onRowToggle={(e) => setExpandedRows(e.data)}
                tableStyle={{ fontSize: '14px' }}
                value={reservations}
                loading={loading}
                ref={dt}
                filters={filters}
                emptyMessage={emptyMessageTemplate}
                globalFilterFields={['employeeName', 'employeeSurname']}
                dataKey="planId"
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 15]}
                paginatorLeft={footerLeftTemplate}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate={
                  t('visitor.from') +
                  ' {totalRecords} ' +
                  t('visitor.record') +
                  ' ' +
                  t('visitor.in') +
                  ' {first}. ' +
                  t('visitor.and') +
                  ' {last}. ' +
                  t('visitor.records-shown')
                }
                responsiveLayout="scroll">
                <Column expander style={{ maxWidth: '3rem' }} />
                <Column field="employeeName" header={t('visitor.name')} sortable style={{ maxWidth: '10rem' }} />
                <Column field="employeeSurname" header={t('visitor.surname')} sortable style={{ maxWidth: '10rem' }} />
                <Column
                  field="eMail"
                  header={t('visitor.email')}
                  sortable
                  style={{ maxWidth: '10rem', minWidth: '8rem' }}
                />
                <Column field="firmName" header={t('visitor.employee-firm')} sortable style={{ maxWidth: '10rem' }} />
                <Column
                  field="locationName"
                  header={t(isShared ? 'visitor.shared-location' : 'visitor.firm-location')}
                  sortable
                  style={{}}
                />
                <Column
                  field="blockName"
                  header={t('most-used-words.block')}
                  sortable
                  filter
                  showFilterMatchModes={false}
                  showFilterMenuOptions={false}
                  filterElement={blockFilterTemplate}
                />
                <Column
                  field="floorName"
                  header={t('most-used-words.floor')}
                  sortable
                  filter
                  showFilterMatchModes={false}
                  showFilterMenuOptions={false}
                  filterElement={floorFilterTemplate}
                />
                <Column field="reservationDate" header={t('input-texts.date')} sortable body={dateBodyTemplate} />
                {isShared && (
                  <Column field="plate" header={t('park-area-res-modal.licence-plate')} body={plateBodyTemplate} />
                )}
                <Column
                  field="status"
                  header={t('visitor.reservation-status')}
                  body={statusBodyTemplate}
                  sortable
                  filter
                  showFilterMatchModes={false}
                  showFilterMenuOptions={false}
                  filterElement={statusFilterTemplate}
                />
                <Column
                  field="visited"
                  header={t('visitor.came-office')}
                  body={checkboxBodyTemplate}
                  sortable
                  filter
                  showFilterMatchModes={false}
                  showFilterMenuOptions={false}
                  filterElement={visitedFilterTemplate}
                />
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </Private>
  )
}
